module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padding-md"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.searchForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单号"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.searchForm.outTradeNo),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "outTradeNo", $$v)
      },
      expression: "searchForm.outTradeNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品ID"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.searchForm.productId),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "productId", $$v)
      },
      expression: "searchForm.productId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户ID"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.searchForm.userId),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "userId", $$v)
      },
      expression: "searchForm.userId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商户ID"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.searchForm.transactionId),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "transactionId", $$v)
      },
      expression: "searchForm.transactionId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "进展"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchForm.progress),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "progress", $$v)
      },
      expression: "searchForm.progress"
    }
  }, _vm._l((_vm.orderConfig), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "native-type": "submit"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.loadData($event)
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.orders,
      "stripe": true,
      "border": ""
    }
  }, [(false) ? _c('el-table-column', {
    attrs: {
      "prop": "id",
      "width": "80",
      "label": "ID"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "transactionId",
      "label": "订单号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productId",
      "label": "商品"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._find_(_vm.products, {
          id: parseInt(scope.row.productId)
        }).name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userId",
      "label": "用户ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalFee",
      "label": "总费用/元"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(_vm._s(_vm._f("currency")(scope.row.totalFee)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outTradeNo",
      "label": "商户ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "progress",
      "label": "订单状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(_vm._s(Object.assign({}, _vm._find_(_vm.orderConfig, {
          value: scope.row.progress
        })).label))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticClass: "padding-vertical-md",
    attrs: {
      "current-page": _vm.pagination.currentPage,
      "page-sizes": _vm.pagination.pageSizes,
      "page-size": _vm.pagination.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pagination.dataCount
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "prev-click": _vm.handlePrevClick,
      "next-click": _vm.handleNextClick
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c416f472","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/orders.vue
// module id = wOE7
// module chunks = 3